import {
  FAQ_ITEMS,
  FEATURE_CARDS,
  HERO_STATS,
  HOW_IT_WORKS_STEPS,
  STORE_BADGES,
  TRUST_POINTS,
} from '@/features/home/constants/home.constants';
import { useDocumentTitle } from '@/hooks/useDocumentTitle.hook';
import type { FaqItem, FeatureCard, HeroStat, HowItWorksStep, StoreBadge, TrustPoint } from '@/types/home.types';

interface UseHomePageResult {
  heroStats: HeroStat[];
  steps: HowItWorksStep[];
  features: FeatureCard[];
  trustPoints: TrustPoint[];
  faqItems: FaqItem[];
  storeBadges: StoreBadge[];
}

export const useHomePage = (): UseHomePageResult => {
  useDocumentTitle(
    'Shoutt | Rent what you need, from students on your own campus',
    'Shoutt is a campus-only rental marketplace for verified college students in India. Rent cameras, cycles, instruments and more from people you can actually find tomorrow.',
  );

  return {
    heroStats: HERO_STATS,
    steps: HOW_IT_WORKS_STEPS,
    features: FEATURE_CARDS,
    trustPoints: TRUST_POINTS,
    faqItems: FAQ_ITEMS,
    storeBadges: STORE_BADGES,
  };
};
